<template>
  <div id="app" class="p-3">
    <Index msg="Markedoc生成器"/>
  </div>
</template>

<script>
import Index from './components/Index.vue'

export default {
  name: 'app',
  components: {
    Index
  }
}
</script>
<style lang="scss" scoped>
</style>
